module.exports = __webpack_public_path__ + "img/raised-hand.83ce846b.png";